<template>
  <div>
    <div style="width: 100%;z-index: 999999999;fixed:none;background: #fbfbfb">
      <!-- <div class="status_bar" :style="{height:h+'px'}">
      </div>-->
      <div class="titlebarbar" :style="{color:textColor}">
        <!-- <img
          src="'../../static/w-titleBar2.png"
          style="left: 2%;position: absolute;"
          @click="back()"
        />-->
        <div class="el-icon-arrow-left" style="z-index: 2;font-weight: 400;font-size:x-large" v-show="show" @click="back()"></div>
        <div class="textCenter" :style="{'transform':'translateX('+translateX+'px)'}" >{{title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h: 0
    };
  },
  // created(){
  // 	let $h = uni.getSystemInfoSync();
  // 	console.log($h);
  // 	this.h = $h.statusBarHeight;
  // },
  name: "wtitleBar",
  props: {
    //标题栏是否固定 可选值fixed 固定 none不固定
    fixed: {
      type: String,
      default: "fixed"
    },
    //返回按钮的颜色  0是白色 1是黑色
    returnColor: {
      type: Number,
      default: 1
    },
    //标题名称  默认首页
    title: {
      type: String,
      default: "首页"
    },
    //背景颜色  默认白色
    bgColor: {
      type: String,
      default: "#ffffff"
    },
    textColor: {
      type: String,
      default: "#000000"
    },
    show: {
      type: Boolean,
      default: true
    },
    translateX: {
      type: Number,
      default: -11
    }
  },

  methods: {
    back() {
      // this.$router.back();
      // var that = this;
      // try {
      //   setTimeout(() => {
      //       let path = window.location.hash.slice(1);
      //       that.$router.replace(path)
      //   }, 1);
      //   return false
      // }catch (e) {

      // }
      this.$router.replace({path: '/home'})
    }
  }
};
</script>

<style>
.status_bar {
  height: var(--status-bar-height);
  width: 100%;
}
.titlebarbar {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
  font-size: 18px;
  font-weight: bold;
}
.titlebarbar image {
  margin-left: 32px;
  width: 16px;
  height: 16px;
}
.textLeft {
  text-align: left;
}
.textCenter {
  font-family: PingFang;
  text-align: center;
  line-height: 44px;
  /* margin-left: -24px; */
  transform: translateX(-11px);
  width: 100%;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/w-titleBar.vue